import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { totalBonuses, totalVolumes } from '../data/offer';
export function GuaranteeSection() {
  return <section className="bg-cream warm-glow-light py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-94" data-mp="9ttgc9z21wy4">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-95" data-mp="etpo8kavi8iy">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-2xl border border-line bg-white p-8 shadow-card sm:p-12" data-id="element-96" data-mp="er35doij86lf">
          <span className="inline-flex rounded-full bg-forest p-4 text-white" data-id="element-97" data-mp="sn6y1ddrc6vs">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-98" data-mp="xm1o90e20xpx" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold text-ink" data-id="element-99" data-mp="12kl90xgww3gp">
            Complete 7-day guarantee
          </h2>
          <p className="mt-4 leading-relaxed text-muted" data-id="element-100" data-mp="25rx6qgm90hvt">
            Open all {totalVolumes} volumes. Review all {totalBonuses} bonuses. Use them in your most challenging
            geology class this week. If you feel your students didn't respond better or the materials didn't save you
            hours of work:
          </p>
          <p className="mt-6 rounded-lg bg-mossSoft px-5 py-4 text-lg font-extrabold text-forest" data-id="element-101" data-mp="1rt7cr9uq6ybo">
            We refund 100% of your money. No questions. No forms. No complications.
          </p>
          <p className="mt-5 text-sm leading-relaxed text-muted" data-id="element-102" data-mp="2jj24te9yx241">
            Because if this collection doesn't deliver the value we promise, we don't want to keep your money.
          </p>
        </motion.div>
      </div>
    </section>;
}